import useAxios from 'axios-hooks';
import React, { useEffect, useState } from 'react';
import FeaturedList from './FeaturedList';

const Series = ({moveItem, addItem, saveIndividual, showUpdateBtn, removeItem, cobrandId, model}) => {
  const [{ data, loading }] = useAxios({ url: `internal/cobrand/series`, method: "get" });
    return (
        <FeaturedList 
        moveItem={(index, direction) => moveItem("series", index, direction)}
        addItem={(option) => addItem("series", option)}
        removeItem={(id) => removeItem("series", id)}
        saveIndividual={saveIndividual}
        showUpdateBtn={showUpdateBtn}
        typeId={8}
        type="Series" 
        model={model} 
        availableItems={data} />
    );
};

export default Series;